import { observer } from 'mobx-react';
import { DraggableProvided } from '@hello-pangea/dnd';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../Translations';
import DragIndicatorIcon from '../../../../Cutesies/DragIndicatorIcon';
import CopyIcon from '../../../../Cutesies/ListIcon';
import LearningCollectionEditStore from '../../Edit/Store';
import { Section, sectionContext } from '../../Types';
import CustomizeExperiences from './CustomizeExperiences';
import CustomizeLearningDesignDetails from './CustomizeLearningDesignDetails';
import ExperienceCatalogButton from './ExperienceCatalogButton';
import CollectionAccordian from './OtherProductCollections/CollectionAccordian';
import { LearningCollectionEditFormResource } from '../../Edit/Store/Types';

interface Props {
  store: LearningCollectionEditStore;
  section: Section;
  provided: DraggableProvided;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

function SectionContent({ store, section, provided, learningCollectionEditFormResource }: Props) {
  switch (section.kind) {
    case 'learning-design-section':
      return (
        <CustomizeExperiences
          key={section.resource.payload.id}
          store={store}
          openByDefault
          titleIcon={
            <div className="flex gap-4">
              <div
                className="inline-block cursor-grab"
                {...provided.dragHandleProps}
                aria-label="Drag to reorder section"
              >
                <DragIndicatorIcon />
              </div>
              <CopyIcon />
            </div>
          }
          titleJSX={<CustomizeLearningDesignDetails section={section} store={store} />}
          countDisplay={
            <T
              kind="Includes <span>{{count}} program(s)</span>"
              span={(content) => <span className="font-semibold">{content}</span>}
              count={store.experienceStores(sectionContext(section)).length}
            />
          }
          customizationActions={
            <ExperienceCatalogButton
              store={store}
              section={section}
              learningCollectionEditFormResource={learningCollectionEditFormResource}
            />
          }
          section={section}
          provided={provided}
        />
      );
    case 'product-collection-section':
      return (
        <CollectionAccordian
          store={store}
          openByDefault={false}
          titleIcon={
            <div className="flex gap-4">
              <div
                className="inline-block cursor-grab"
                {...provided.dragHandleProps}
                aria-label="Drag to reorder collection"
              >
                <DragIndicatorIcon />
              </div>
              <LockClosedIcon className="h-5" />
            </div>
          }
          resource={section.resource}
          countDisplay={
            <T
              kind="Includes <span>{{count}} program(s)</span>"
              span={(content) => <span className="font-semibold">{content}</span>}
              count={section.resource.payload.experiences.length}
            />
          }
          provided={provided}
        />
      );
  }
}

export default observer(SectionContent);
